import {Plugin} from "prosemirror-state";

export const editorBlur = onBlurHandler => new Plugin({
    props: {
        handleDOMEvents: {
            blur: view => {
                if (!view.editable) {
                    return false;
                }
                onBlurHandler && onBlurHandler(view);
                return false;
            }
        }
    }
});